import React, { useState, useEffect } from "react";
import { putApi } from "../../Services/apiService"; // Use putApi for updates
import moment from 'moment';
const EditOfferModal = ({ setEditOfferModal, fetchOffers, offerData }) => {
    console.log("offerData" , offerData);
    
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    offer_code: "",
  
    expiry_date: "",
    category_id: "1",
    description: "", // Default category_id
    image: null,
  });

  const [error, setError] = useState("");
  const [filePreviews, setFilePreviews] = useState({
    image: null,
  });

  // Pre-fill the form with existing offer data
  useEffect(() => {
    if (offerData) {
      setFormData({
        title: offerData.title || "",
        offer_code: offerData.offer_code || "",
        description: offerData.description || "",
        expiry_date: offerData.expiry_date
          ? new Date(offerData.expiry_date).toISOString().split("T")[0]
          : "",
        category_id: offerData.category_id || "1",
        image: null, // Reset image file (handle existing image separately)
      });

      // Set existing image preview from API response
      if (offerData.image) {
        setFilePreviews({ image: offerData.image });
      }
    }
  }, [offerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (error[name]) {
      setError({ ...error, [name]: '' });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Update formData with the file
      setFormData({ ...formData, image: file });

      // Create a preview URL for the image
      const previewURL = URL.createObjectURL(file);
      setFilePreviews({ ...filePreviews, image: previewURL });
    }
  };

  const handleRemoveFile = () => {
    // Clear the image file and preview
    setFormData({ ...formData, image: null });
    setFilePreviews({ ...filePreviews, image: null });
  };


  const validateForm = () => {
    let formErrors = {};
    if (!formData.title.trim()) {
      formErrors.title = "Title is required.";
    } else if (formData.title.trim().length < 2 || formData.title.trim().length > 35) {
      formErrors.title = "Title must be between 2 and 35 characters.";
    }

    if (!formData.description.trim()) {
      formErrors.description = "Description is required.";
    } else if (formData.description.trim().length < 2 || formData.description.trim().length > 250) {
      formErrors.description = "Description must be between 2 and 250 characters.";
    }

    if (!formData.offer_code.trim()) formErrors.offer_code = "Offer code is required.";
    if (!formData.expiry_date) formErrors.expiry_date = "Expiry date is required.";
    if (!formData.category_id) formErrors.category_id = "Category is required.";

    setError(formErrors);
    return Object.keys(formErrors).length === 0;
  };



  const handleSubmit = async (e) => {

    setLoader(true);
    if (!validateForm()) {
      setLoader(false); // Stop the loader if validation fails
      return;
    }
    // Validate required fields
    if (
      !formData.title ||
      !formData.offer_code ||
      !formData.description ||
      !formData.expiry_date
    ) {
      setError("All required fields must be provided.");
      setLoader(false);
      return;
    }

    try {
      // Format expiry_date to Unix timestamp in milliseconds
      const expiryDateTimestamp = new Date(formData.expiry_date).getTime();

      // Create FormData for file upload
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("offer_code", formData.offer_code);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("expiry_date", expiryDateTimestamp); // Send formatted expiry_date
      formDataToSend.append("category_id", formData.category_id);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      // Make API call to update offer
      const response = await putApi(`/admin/offer/${offerData.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setEditOfferModal(false);
        fetchOffers();
      }
    } catch (err) {
      setError("Failed to update offer. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="detail-page-modal">
      <div className="modal-header">
        <h3>Edit Offer</h3>
        <button className="close-button" onClick={() => setEditOfferModal(false)}>
          <img
            src={window.getPublicUrl("/assets/images/Close_round_light.svg")}
            alt="close"
          />
        </button>
      </div>
      <div className="modal-body scrollable-modal-body">
        <div className="input-main">
          <div className="row">
            {Object.keys(formData).map((key) =>
              key !== "image" && key !== "category_id" && key !== "description" ? (
                <div className={key === "expiry_date" ? "col-sm-12" : "col-sm-6"} key={key}>
                  <div className="custom-floating-group">
                    <input
                      type={key === "expiry_date" ? "date" : "text"}
                      name={key}
                      placeholder=" "
                      value={key === "expiry_date" ? moment(formData[key]).format("YYYY-MM-DD") : formData[key]}
                      min={key === "expiry_date" ? moment().format("YYYY-MM-DD") : null} // Disable previous dates
                      onChange={handleChange}
                    />
                    <label>{key.replace("_", " ")}</label>
                    {error[key] && <span style={{ color: "red", fontSize: "14px" }}>{error[key]}</span>}
                  </div>
                </div>
              ) : null
            )}
         

          <div className="col-sm-6">
  <div className="custom-floating-group position-relative height">
    <textarea
      name="description"
      value={formData.description}
      onChange={handleChange}
      placeholder=" "
      rows="4"
      className={`custom-textarea ${formData.description ? "has-content" : ""}`}
    ></textarea>
    <label className="floating-label">Description</label>
    {error.description && (
      <span style={{ color: "red", fontSize: "14px" }}>
        {error.description}
      </span>
    )} 
  </div>
</div>

          {/* Image Upload Section */}
          <div className="col-sm-6">
            <div className="upload-wrapper">
              <input
                type="file"
                id="image"
                name="image"
                className="upload-input"
                onChange={handleFileChange}
                accept="image/*"
              />
              <label htmlFor="image" className="upload-label">
                <img
                  className="upload-icon"
                  src={window.getPublicUrl("/assets/images/upload.svg")}
                  alt="upload"
                />
                Upload Image
                <div className="upload-box">
                {error.image && (
                    <span style={{ color: "red", fontSize: "14px" }}>
                      {error.image}
                    </span>
                  )}
                  {filePreviews.image && (
                    <div className="file-preview">
                      <img
                        src={
                          typeof filePreviews.image === "string"
                            ? filePreviews.image // Use the URL from the API response
                            : filePreviews.image // Use the preview URL for newly uploaded files
                        }
                        alt="Preview"
                      />
                      {/* <button
                        className="cross"
                        onClick={handleRemoveFile}
                      >
                        <img
                          src={window.getPublicUrl(
                            "/assets/images/gray-cross.svg"
                          )}
                          alt="remove"
                        />
                      </button> */}
                    </div>
                  )}
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div className="modal-footer">
        <button className="cancel" onClick={() => setEditOfferModal(false)}>
          Cancel
        </button>
        <button className="save" onClick={handleSubmit} disabled={loader}>
          {loader && <div className="spinner-border" role="status"></div>}
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EditOfferModal;